import React from "react";

/**
 * Dismissible banner when pending tasks are in the Aging warn window.
 * Dismiss is stored in localStorage so it survives login and app relaunch.
 *
 * Reuses catch-up banner visual classes so it sits consistently under the
 * action-items toolbar.
 *
 * @example
 * <ActionItemsAgingBanner
 *   count={3}
 *   onDismiss={() => {}}
 *   onReview={() => {}}
 * />
 */
const ActionItemsAgingBanner = ({ count, onDismiss, onReview }) => {
  const agingCount = Number(count) || 0;
  if (agingCount <= 0) {
    return null;
  }

  const label = `${agingCount} task${agingCount === 1 ? "" : "s"} ha${
    agingCount === 1 ? "s" : "ve"
  } gone quiet`;

  return (
    <div className="action-items-catch-up-banner" role="status" aria-live="polite">
      <p className="action-items-catch-up-banner__text">
        <span className="action-items-catch-up-banner__segment">
          <strong>{label}</strong>
          <span className="action-items-catch-up-banner__suffix">
            — we&apos;ll archive them after 30 days
          </span>
        </span>
        <span className="action-items-catch-up-banner__segment">
          <span className="action-items-catch-up-banner__sep" aria-hidden="true">
            ·
          </span>
          <button
            type="button"
            className="action-items-catch-up-banner__link"
            onClick={onReview}
          >
            Review aging
          </button>
        </span>
      </p>
      <button
        type="button"
        className="action-items-catch-up-banner__close"
        onClick={onDismiss}
        aria-label="Dismiss aging summary"
        title="Dismiss"
      >
        ×
      </button>
    </div>
  );
};

export default ActionItemsAgingBanner;
